import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { OzBoxColors } from '@@/library/v4/components/OzBox.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzPopoverTip',
  props: {
    color: { default: OzBoxColors.Primary },
    darkMode: { type: [Boolean, String], default: 'auto' },
    pathClasses: { default: () => [] }
  },
  setup(__props: any) {



return { __sfc: true,OzBoxColors }
}

})